import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';
import { API_URL } from '../utils/config';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.email, formData.password);
    
    if (result.success) {
      alert('Login successful!');
      navigate('/');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  // Google OAuth Login - FIXED: Using backticks instead of single quotes
  const handleGoogleLogin = () => {
    // Redirect to backend Google OAuth endpoint
    window.location.href = `${API_URL}/api/auth/google`;
  };

  // Facebook OAuth Login - FIXED: Using backticks instead of single quotes
  const handleFacebookLogin = () => {
    // Redirect to backend Facebook OAuth endpoint
    window.location.href = `${API_URL}/api/auth/facebook`;
  };

  return (
    <section id="loginsection">
      <div className="container">
        {/* Google OAuth Button */}
        <button 
          onClick={handleGoogleLogin} 
          className="btng"
          type="button"
        >
          <i className="fab fa-google"></i>
          <span>Google</span>
        </button>

        {/* Facebook OAuth Button */}
        <button 
          onClick={handleFacebookLogin} 
          className="btnf"
          type="button"
        >
          <i className="fab fa-facebook-f"></i>
          <span>Facebook</span>
        </button>

        <div className="drop">
          <div className="content">
            <h2>Log In</h2>
            
            {error && (
              <div className="error-message" style={{
                color: '#ff0f5b',
                padding: '10px',
                marginBottom: '10px',
                fontSize: '0.9em'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="inputBox">
                <input
                  type="email"
                  placeholder="Email Address"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="inputBox">
                <input
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="inputBox">
                <input 
                  type="submit" 
                  value={loading ? "Logging in..." : "Login"}
                  disabled={loading}
                />
              </div>
            </form>
          </div>
        </div>
        
        <Link to="/signup" className="btns">Signup</Link>
        <a href="#home" className="btns signup">Forget</a>
      </div>
    </section>
  );
};

export default Login;